import {
  TipoUtenteCardinalitaDTO,
  useGetFrontTipiUtente,
} from '@framework/api-client';
import { t, useTranslation } from '@framework/i18n';
import * as React from 'react';
import styled from 'styled-components';
import { InquiryItemDivider } from './InquiryItemDivider';

const UserKindText = styled.div`
  font-size: 18px;
`;

const RecipientTypeText = {
  DIPENDENTE: t('recipient-type.dipendente', 'Dipendente'),
  ENTE_PUBBLICO: t('recipient-type.ente-pubblico', 'Ente Pubblico'),
  PERSONA_FISICA: t('recipient-type.persona-fisica', 'Persona Fisica'),
  PERSONA_GIURIDICA: t('recipient-type.persona-giuridica', 'Persona Giuridica'),
};

export interface IInquiryRecipientTypeRenderProps {
  recipients?: TipoUtenteCardinalitaDTO[] | null;
}

export function InquiryRecipientTypeRender(
  props: IInquiryRecipientTypeRenderProps,
) {
  const { recipients } = props;

  const { t } = useTranslation();

  const { data: userKinds } = useGetFrontTipiUtente({
    query: { keepPreviousData: true },
  });
  if (!userKinds || !recipients) return null;

  const translatedUserKinds = userKinds.map(userKind => ({
    ...userKind,
    descrizione:
      RecipientTypeText[userKind.codice as keyof typeof RecipientTypeText] ??
      userKind.descrizione,
  }));
  console.log({ translatedUserKinds });
  return (
    <div>
      <div>{t('domanda.copertina.destinatari', 'Destinatari')}:</div>
      {recipients.map(recipient => {
        const userKind = translatedUserKinds.find(
          userKind => userKind.id === recipient.idTipoUtente,
        );
        return (
          userKind && (
            <UserKindText key={userKind.id}>
              {userKind.descrizione}
            </UserKindText>
          )
        );
      })}
      <InquiryItemDivider />
    </div>
  );
}
